import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsxs as a, jsx as e } from "react/jsx-runtime";
import n from "classnames";
import { useState as t, useEffect as i } from "react";
!function (a, e) {
  void 0 === e && (e = {});
  var n = e.insertAt;
  if (a && "undefined" != typeof document) {
    var t = document.head || document.getElementsByTagName("head")[0],
      i = document.createElement("style");
    i.type = "text/css", "top" === n && t.firstChild ? t.insertBefore(i, t.firstChild) : t.appendChild(i), i.styleSheet ? i.styleSheet.cssText = a : i.appendChild(document.createTextNode(a));
  }
}(".radio__root {\n  display: flex;\n  align-items: center;\n}\n.radio__label {\n  font-size: var(--phx-fontSizeNormal, 1rem);\n  color: var(--phx-secondaryTextColor, #4a4a4a);\n  margin-bottom: 5px;\n  padding-left: 5px;\n  cursor: pointer;\n}\n.radio__input {\n  width: var(--phx-fieldRadioInputWidth, 17px);\n  height: var(--phx-fieldRadioInputHeight, 17px);\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  display: inline-block;\n  padding: 2px;\n  background-clip: content-box;\n  border: var(--phx-fieldRadioInputBorder, 2px solid #bbbbbb);\n  background-color: var(--phx-fieldInputBackground, #fff);\n  border-radius: 50%;\n  cursor: pointer;\n}\n.radio__input:checked {\n  background-color: var(--phx-textColor, #707070);\n}\n.radio__error-message {\n  color: var(--phx-error, #f20202);\n  font-size: var(--phx-fontSizeSmall, 0.75rem);\n  margin: 10px 0 5px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJhZGlvLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFhO0VBQ2IsbUJBQW1CO0FBQ3JCO0FBQ0E7RUFDRSwwQ0FBMEM7RUFDMUMsNkNBQTZDO0VBQzdDLGtCQUFrQjtFQUNsQixpQkFBaUI7RUFDakIsZUFBZTtBQUNqQjtBQUNBO0VBQ0UsNENBQTRDO0VBQzVDLDhDQUE4QztFQUM5Qyx3QkFBZ0I7S0FBaEIscUJBQWdCO1VBQWhCLGdCQUFnQjtFQUNoQixxQkFBcUI7RUFDckIsWUFBWTtFQUNaLDRCQUE0QjtFQUM1QiwyREFBMkQ7RUFDM0QsdURBQXVEO0VBQ3ZELGtCQUFrQjtFQUNsQixlQUFlO0FBQ2pCO0FBQ0E7RUFDRSwrQ0FBK0M7QUFDakQ7QUFDQTtFQUNFLGdDQUFnQztFQUNoQyw0Q0FBNEM7RUFDNUMsa0JBQWtCO0FBQ3BCIiwiZmlsZSI6InJhZGlvLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIucmFkaW9fX3Jvb3Qge1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuLnJhZGlvX19sYWJlbCB7XG4gIGZvbnQtc2l6ZTogdmFyKC0tcGh4LWZvbnRTaXplTm9ybWFsLCAxcmVtKTtcbiAgY29sb3I6IHZhcigtLXBoeC1zZWNvbmRhcnlUZXh0Q29sb3IsICM0YTRhNGEpO1xuICBtYXJnaW4tYm90dG9tOiA1cHg7XG4gIHBhZGRpbmctbGVmdDogNXB4O1xuICBjdXJzb3I6IHBvaW50ZXI7XG59XG4ucmFkaW9fX2lucHV0IHtcbiAgd2lkdGg6IHZhcigtLXBoeC1maWVsZFJhZGlvSW5wdXRXaWR0aCwgMTdweCk7XG4gIGhlaWdodDogdmFyKC0tcGh4LWZpZWxkUmFkaW9JbnB1dEhlaWdodCwgMTdweCk7XG4gIGFwcGVhcmFuY2U6IG5vbmU7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgcGFkZGluZzogMnB4O1xuICBiYWNrZ3JvdW5kLWNsaXA6IGNvbnRlbnQtYm94O1xuICBib3JkZXI6IHZhcigtLXBoeC1maWVsZFJhZGlvSW5wdXRCb3JkZXIsIDJweCBzb2xpZCAjYmJiYmJiKTtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tcGh4LWZpZWxkSW5wdXRCYWNrZ3JvdW5kLCAjZmZmKTtcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuICBjdXJzb3I6IHBvaW50ZXI7XG59XG4ucmFkaW9fX2lucHV0OmNoZWNrZWQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1waHgtdGV4dENvbG9yLCAjNzA3MDcwKTtcbn1cbi5yYWRpb19fZXJyb3ItbWVzc2FnZSB7XG4gIGNvbG9yOiB2YXIoLS1waHgtZXJyb3IsICNmMjAyMDIpO1xuICBmb250LXNpemU6IHZhcigtLXBoeC1mb250U2l6ZVNtYWxsLCAwLjc1cmVtKTtcbiAgbWFyZ2luOiAxMHB4IDAgNXB4O1xufSJdfQ== */");
var o = function o(_ref) {
  var o = _ref.name,
    d = _ref.onChange,
    r = _ref.classes,
    c = _ref.defaultValue,
    _ref$options = _ref.options,
    l = _ref$options === void 0 ? [] : _ref$options,
    s = _ref.error;
  var _t = t(c || ""),
    _t2 = _slicedToArray(_t, 2),
    b = _t2[0],
    p = _t2[1];
  i(function () {
    d({
      name: o,
      value: b
    });
  }, [b]);
  var m = function m(_ref2) {
    var a = _ref2.target.value;
    p(a);
  };
  return a("div", Object.assign({
    className: n(null == r ? void 0 : r.container, "radio__container"),
    "data-testid": "radio-container"
  }, {
    children: [l.map(function (_ref3) {
      var t = _ref3.key,
        i = _ref3.label;
      return a("div", Object.assign({
        className: n(null == r ? void 0 : r.root, "radio__root")
      }, {
        children: [e("div", Object.assign({
          className: "radio__input-wrapper"
        }, {
          children: e("input", {
            className: n(null == r ? void 0 : r.input, "radio__input"),
            name: "".concat(o, "-").concat(t),
            onChange: m,
            id: "".concat(o, "-").concat(t),
            type: "radio",
            value: t,
            checked: t === b,
            "data-testid": "radio-".concat(t)
          })
        })), i ? e("label", Object.assign({
          className: n(null == r ? void 0 : r.label, "radio__label"),
          htmlFor: "".concat(o, "-").concat(t)
        }, {
          children: i
        })) : null]
      }), t);
    }), s ? e("p", Object.assign({
      className: "radio__error-message",
      "data-testid": "radio-error"
    }, {
      children: s
    })) : null]
  }));
};
export { o as Radio };